import React, { useEffect } from 'react';
import niceNameForShippingMethod from '../niceNameForShippingMethod';

const getMethodExamples = (examples, method) => (
    (examples || []).filter((example) => example.method === method && Number(example.rate) > 0)
);

const getRange = (examples, method) => {
    const rates = getMethodExamples(examples, method).map((example) => Number(example.rate));
    if (rates.length === 0) return null;
    return {
        min: Math.min(...rates),
        max: Math.max(...rates),
    };
};

export default function RatesStep({
    state,
    setField,
    examples,
    examplesLoading,
    fetchExamples,
}) {
    const methodsNeedingRates = (state.methods || []).filter((method) => method !== 'LOCAL_PICKUP');
    const rates = state.rates || {};

    useEffect(() => {
        if (!examplesLoading && (!examples || examples.length === 0)) {
            fetchExamples();
        }
    }, []);

const setRate = (method, value) => {
    const parsed = parseFloat(value);
    setField('rates', {
        ...rates,
        [method]: value === '' || Number.isNaN(parsed) ? '' : parsed,
    });
};

    if (methodsNeedingRates.length === 0) {
        return (
            <div className="shipping-step">
                <h3>Flat Rates</h3>
                <p className="help">Local pickup is always free, so no rates are needed.</p>
            </div>
        );
    }

    return (
        <div className="shipping-step">
            <h3>Flat Rates</h3>
            {examplesLoading && <p className="help">Loading example rates...</p>}
            {methodsNeedingRates.map((method) => {
                const range = getRange(examples, method);
                const suggestedRate = range ? Math.ceil(range.max).toFixed(2) : null;

                return (
                    <div key={method} className="group">
                        <label>Rate for {niceNameForShippingMethod(method)}</label>
                        <input
                            type="number"
                            step="0.01"
                            min="0"
                            value={rates[method] || ''}
                            onChange={(e) => setRate(method, e.target.value)}
                            required
                        />
                        {range && (
                            <p className="help">
                                Example rates ranged ${range.min.toFixed(2)}-${range.max.toFixed(2)}.
                                {' '}
                                <button
                                    type="button"
                                    className="shipping-chip"
                                    onClick={() => setRate(method, suggestedRate)}
                                >
                                    Use ${suggestedRate}
                                </button>
                            </p>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
